import { useCallback, useEffect } from "react";

const useBeforeUnload = (unsavedChanges) => {

  const handleBeforeUnload = useCallback((event) => {
    if (unsavedChanges) {
      event.preventDefault();
      event.returnValue = "";
    }
  }, [unsavedChanges]);

  useEffect(() => {
    if (unsavedChanges) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    } else {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [handleBeforeUnload, unsavedChanges]);

  return null
};

export default useBeforeUnload;
